import React from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import './PriceRangeFilter.css';
import LoadingSpinner from './LoadingSpinner';

const PriceRangeFilter = ({ initialRange, selectedRange, onPriceChange, isLoading = false }) => {
    const validInitialRange = {
        min: initialRange && initialRange.min !== undefined ? initialRange.min : 0,
        max: initialRange && initialRange.max !== undefined ? initialRange.max : 100000
    };

    // Предотвращаем ситуацию когда min == max (слайдер не работает корректно в таком случае)
    const sliderMin = validInitialRange.min;
    const sliderMax = validInitialRange.max === validInitialRange.min ? 
                     validInitialRange.min + 1 : validInitialRange.max;
    
    const handleRangeChange = (newRange) => {
        onPriceChange(newRange[0], newRange[1]);
    };
  
    return (
        <div className="price-range-filter">
            <div className="mb-3 mt-2">
                <h5 className="filter-section-title">Цена</h5>
            </div>
        
            {isLoading ? (
                <div className="py-3">
                    <LoadingSpinner message="Загрузка диапазона цен..." size="sm" />
                </div>
            ) : (
                <>
                    <div className="slider-container mb-3">
                        <Slider
                            range
                            min={sliderMin}
                            max={sliderMax}
                            defaultValue={[sliderMin, sliderMax]}
                            value={[selectedRange.min, selectedRange.max]}
                            onChange={handleRangeChange}
                            trackStyle={[{ backgroundColor: '#ffc107' }]}
                            handleStyle={[
                                { borderColor: '#ffc107', backgroundColor: '#ffc107' },
                                { borderColor: '#ffc107', backgroundColor: '#ffc107' }
                            ]}
                            railStyle={{ backgroundColor: '#e9ecef' }}
                        />
                    </div>
                    
                    <div className="price-range-labels d-flex justify-content-between">
                        <span>{selectedRange.min} ₽</span>
                        <span>{selectedRange.max} ₽</span>
                    </div>
                </>
            )}
        </div>
    );
};

export default PriceRangeFilter;